//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import nieuwsbericht from '~/graphql/queries/nieuwsbericht.gql';
import nieuwsberichten from '~/graphql/queries/nieuwsberichten.gql';

export default {
  auth: false,
  apollo: {
    nieuwsBerichten: {
      query: nieuwsberichten,
      variables() {
        return {
          limit: this.amount + 1,
        };
      },
    },
    nieuwsBericht: {
      query: nieuwsbericht,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data: () => ({
    nieuwsBericht: null,
    nieuwsBerichten: {
      data: [],
    },
    amount: 4,
  }),
  computed: {
    filteredNieuws() {
      return this.nieuwsBerichten.data.filter(n => !this.nieuwsBericht || n.slug !== this.nieuwsBericht.slug).slice(0, this.amount);
    },
  },
  head() {
    return {
      title: this.nieuwsBericht?.title || this.$route.params.slug,
    };
  },
};
